export const NUM_OF_PLAYERS_PER_PAGE = 14;
export const RANKING_PAGINATION_INTERVAL_IN_MS = 10000;
